<scope-ui-table
  [has-privilege]="Privilege.SCOPE__VIEW_FEES"
  tableClass="nested fees-table shrunk-table"
  [loggedInUser]="authService.loggedInUser"
  [unmappedData]="parent.feeItems | orderBy: 'id'"
  [displayedColumns]="columns"
  [parentEntity]="parent"
  [level]="level"
  [convertCurrency]="config?.currency"
  [disableDragging]="scopeElementsService.disableDragging"
  [menuOptions]="feeMenuOptions"
  [showToggleMenu]="!!feeMenuOptions?.length"
  [addToggleListColumn]="!!feeMenuOptions?.length"
  [noSort]="true"
  [noPagination]="true"
  [noPreferences]="true"
  [expandable]="false"
  [showFooterRow]="true"
  [headerExpandable]="true"
  [(tableExpanded)]="tableStates[parent.id]"
  (updateFeeItem)="onUpdateFeeItem.emit($event)">
</scope-ui-table>
